
/**
 * @mixin Compute DOM event listeners so they can be attached to an element and emitted directly.
 */
export default {
    computed: {
        listeners() {
            const listeners = this.$listeners;
            return Object.keys(listeners).filter(key => ({
                click: true,
                keydown: true,
                keyup: true,
                mousedown: true,
                mouseenter: true,
                mouseleave: true,
                mousemove: true,
                mouseover: true,
                mouseout: true,
                mouseup: true,
                scroll: true,
                touchend: true,
                touchmove: true,
                touchstart: true
            })[key] === true).reduce((o,key) => {
                o[key] = listeners[key];
                return o;
            }, {});
        }
    }
}
